<pop-error-wrapper>
  <h1 title
      translate="PAGES.UNAUTHORIZED.TITLE"></h1>
  <p description
     translate="PAGES.UNAUTHORIZED.DESCRIPTION"></p>
  <button action
          class="pl-button"
          translate="PAGES.UNAUTHORIZED.RECONNECT"
          (click)="login()"></button>
</pop-error-wrapper>
